export default function Hero() {
  return (
    <section id="home" className="relative w-full h-[100vh] min-h-[720px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={`${import.meta.env.BASE_URL}localized/hero-roaster-firelight-01.jpg`}
          alt="Roaster at work at first light"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/50 via-primary-950/35 to-primary-950/70"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <div className="w-full max-w-4xl reveal">
          <div className="inline-flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-accent-300"></span>
            <span className="text-xs md:text-sm tracking-[0.35em] uppercase text-accent-200">Est. 2011 · Portland, Oregon</span>
            <span className="h-px w-10 bg-accent-300"></span>
          </div>

          <h1 className="font-heading text-background-50 text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.05] mb-8">
            Small-batch coffee,<br />
            <em className="text-accent-300 font-medium">roasted at first light.</em>
          </h1>

          <p className="text-background-100/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
            An unhurried craft — green beans sourced from three continents, coaxed to their peak by hand, one drum at a time. Served warm in our Northwest cafe, delivered fresh to your kitchen table.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#coffee"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-background-50 text-primary-900 text-sm tracking-wide font-medium hover:bg-accent-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>Shop This Week&apos;s Beans</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#visit"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-background-50/60 text-background-50 text-sm tracking-wide font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-2-line w-4 h-4 flex items-center justify-center"></i>
              <span>Visit The Roastery</span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-background-100/70">
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <div className="w-px h-10 bg-background-100/50 animate-pulse"></div>
      </div>
    </section>
  );
}